
  import '/home/ec2-user/Youlify-Design/components/alert/index.$tab-design.zh-CN.md?watch=parent';
  export const texts = [{"value":"Alert的本质是了解页面/模块内需要关注的提示","paraId":0,"tocIndex":0}];
  